import { render, staticRenderFns } from "./travelManage.vue?vue&type=template&id=202b5738&scoped=true&"
import script from "./travelManage.vue?vue&type=script&lang=js&"
export * from "./travelManage.vue?vue&type=script&lang=js&"
import style0 from "./travelManage.vue?vue&type=style&index=0&id=202b5738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b5738",
  null
  
)

export default component.exports